<template>
  <header class="my-40 md:my-50 lg:my-60 xl:my-90 max-w-prose">
    <h1 v-if="title" class="is-1 mb-20 md:mb-0">
      <slot>
        {{ title }}
      </slot>
    </h1>
    <div v-if="lead" class="is-lead mt-40">
      <slot name="lead">
        <div v-html="lead" />
      </slot>
    </div>
  </header>
</template>

<script lang="ts" setup>
defineProps<{
  title?: string
  lead?: string
}>()
</script>
